import { useCallback } from 'react'
import { Caption, Subheader3, Tooltip, Stack } from '@collaborate-health/uikit'
import { QualificationsIcon } from '@tabeeb/shared/icons'
import { sessionTitleFormatter } from '@tabeeb/shared/utils/text'

const SessionRequireQualificationsStatusIcon = () => {
  const renderTooltip = useCallback(() => {
    return (
      <Stack width='250px'>
        <Subheader3 fontSize='14px' fontWeight='bold'>
          Access restricted
        </Subheader3>
        <Caption>
          {sessionTitleFormatter.format('Only users with the required qualifications are able to access this session.')}
        </Caption>
      </Stack>
    )
  }, [])
  return (
    <Tooltip text={renderTooltip()}>
      <QualificationsIcon sx={{ mr: 0.75, fontSize: '16px' }} />
    </Tooltip>
  )
}

export default SessionRequireQualificationsStatusIcon

